import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MrsiService } from 'src/app/mrsi/service/mrsi.service';
import { ReportService } from 'src/app/repository/service/report.service';
import { HomeService } from 'src/app/shared/services/home.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-sub-side-nav-children',
  templateUrl: './sub-side-nav-children.component.html',
  styleUrls: ['./sub-side-nav-children.component.scss']
})
export class SubSideNavChildrenComponent implements OnInit {
  @Input() subMenu:any
  constructor(public sidePanelService:SidePanelService,
    public reportService:ReportService,
    public homeService: HomeService,
    public router: Router,
    public mrsiService:MrsiService) { }

  ngOnInit( ): void {
    // console.log("subMenu in children===>",this.subMenu)
  }

}
